<template>
  <a-tree-select
    allowClear
    labelInValue
    :getPopupContainer="(node) => node.parentNode"
    style="width: 100%"
    :disabled="disabled"
    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
    :placeholder="placeholder"
    :loadData="asyncLoadTreeData"
    :value="treeValue"
    :treeData="treeData"
    :multiple="multiple"
    @change="onChange"
    @search="onSearch"
  >
  </a-tree-select>
</template>
<script>
/*
 * 异步树加载组件 通过传入表名 显示字段 存储字段 加载一个树控件
 * <j-tree-select dict="aa_tree_test,aad,id" pid-field="pid" ></j-tree-select>
 * */
import { getAction } from '@/api/manage'

export default {
  name: 'AtlxTreeSelect',
  props: {
    onlyLeaf: {
      type: Boolean,
      required: false,
      default: true
    },
    value: {
      type: Number,
      required: false
    },
    placeholder: {
      type: String,
      default: '请选择',
      required: false
    },
    actionUrl: {
      type: String,
      default: '',
      required: false
    },
    pidField: {
      type: String,
      default: 'pid',
      required: false
    },
    pidValue: {
      type: String,
      default: '',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    hasChildField: {
      type: String,
      default: '',
      required: false
    },
    condition: {
      type: String,
      default: '',
      required: false
    },
    // 是否支持多选
    multiple: {
      type: Boolean,
      default: false
    },
    loadTriggleChange: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      treeValue: null,
      treeData: []
    }
  },
  watch: {
    value() {
      this.loadItemByCode()
    },
    dict() {
      this.loadRoot()
    }
  },
  created() {
    this.validateProp().then(() => {
      this.loadRoot()
      this.loadItemByCode()
    })
  },
  methods: {
    loadItemByCode() {
      if (!this.value || this.value === '0') {
        this.treeValue = null
      } else {
        getAction(this.actionUrl, { id: this.value }).then((res) => {
          if (res.success) {
            if (this.multiple) {
              let values = this.value.split(',')
              this.treeValue = res.result.result.map((item, index) => ({
                key: values[index],
                value: values[index],
                label: item
              }))
            } else {
              this.treeValue = res.result.result[0]
            }
            this.onLoadTriggleChange(res.result.result[0])
          }
        })
      }
    },
    onLoadTriggleChange(text) {
      //只有单选才会触发
      if (!this.multiple && this.loadTriggleChange) {
        this.$emit('change', this.value, text)
      }
    },
    asyncLoadTreeData(treeNode) {
      return new Promise((resolve) => {
        if (treeNode.$vnode.children) {
          resolve()
          return
        }
        let pid = treeNode.$vnode.key
        let param = {
          pid: pid
        }
        getAction(this.actionUrl, param).then((res) => {
          if (res.success) {
            let treeData = res.result.result.map((item) => ({
              key: item.key,
              parentId: item.pid,
              value: item.key,
              title: item.title,
              code: item.code,
              children: item.children,
              isLeaf: false
            }))
            this.addChildren(pid, treeData, this.treeData)
            this.treeData = [...this.treeData]
          }
          resolve()
        })
      })
    },
    addChildren(pid, children, treeArray) {
      if (treeArray && treeArray.length > 0) {
        for (let item of treeArray) {
          if (item.key === pid) {
            if (!children || children.length === 0) {
              item.isLeaf = true
            } else {
              item.children = children
            }
            break
          } else {
            this.addChildren(pid, children, item.children)
          }
        }
      }
    },
    loadRoot() {
      getAction(this.actionUrl, { levelIdList: '1' }).then((res) => {
        if (res.success && res.result) {
          this.treeData = res.result.result.map((item) => ({
            key: item.key,
            parentId: item.pid,
            value: item.key,
            title: item.title,
            code: item.code,
            children: item.children,
            isLeaf: false
          }))
        } else {
          console.log('数根节点查询结果-else', res)
        }
      })
    },

    onChange(value, label, extra) {
      if (this.onlyLeaf) {
        //只能选择末尾
        if (!extra.triggerNode.isLeaf) {
          this.$message.warning('请选择第四级分类或最末级分类')
          return
        }
      }
      if (!value) {
        this.$emit('change', '')
        this.treeValue = null
      } else if (value instanceof Array) {
        this.$emit('change', value.map((item) => item.value).join(','))
        this.treeValue = value
      } else {
        this.$emit('change', parseInt(value.value), value.label)
        this.treeValue = value
      }
    },
    onSearch(value) {
      console.log(value)
    },
    getCurrTreeData() {
      return this.treeData
    },
    validateProp() {
      let mycondition = this.condition
      return new Promise((resolve, reject) => {
        if (!mycondition) {
          resolve()
        } else {
          try {
            let test = JSON.parse(mycondition)
            console.log('aaaaasdsdd', typeof test)
            if (typeof test === 'object' && test) {
              resolve()
            } else {
              this.$message.error('组件JTreeSelect-condition传值有误，需要一个json字符串!')
              reject()
            }
          } catch (e) {
            this.$message.error('组件JTreeSelect-condition传值有误，需要一个json字符串!')
            reject()
          }
        }
      })
    }
  },
  //2.2新增 在组件内定义 指定父组件调用时候的传值属性和事件类型 这个牛逼
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>
